import axios from "axios";
import { serverUrl } from "../config/envConfig";

export const kioskApi = axios.create({
  baseURL: serverUrl,
  headers: {
    "content-type": "application/json",
  },
  withCredentials: true,
  credentials: "include",
  paramsSerializer: {
    indexes: null,
  },
});
